import { Effect } from "./component-effect";
import { ComponentBehaviourApplication } from "./component-behaviour-application";
import { ActionRow } from "./action-row";

export class ComponentBehaviour {
    public id: string;
    public componentKey: string;
    public serviceId: string;
    public effects: Effect[] = [];
    public ComponentBehaviourApplication: ComponentBehaviourApplication;
    public actions: ActionRow[] = [];
}
